module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/AmfamThemeBuild/Platforms/1604Build/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js-exposed
// module id = 2
// module chunks = 1